<template>
  <a-pagination
    showQuickJumper
    showSizeChanger
    :total="total"
    :current="current"
    :pageSize="pageSize"
    :pageSizeOptions="pageSizeOptions"
    :showTotal="total => `共 ${total} 条`"
    @change="change"
    @showSizeChange="showSizeChange"
    size="small"
    style="margin-top:20px; float:right;"
  />
</template>

<script>
export default {
  name: "Pagination",
  props: ["total", "current", "pageSize"],
  data() {
    return {
      pageSizeOptions: ["1", "5", "10", "15", "20", "25", "30"]
    };
  },
  methods: {
    change(page, pageSize) {
      let pagination = {
        current: page,
        pageSize: pageSize
      };
      try {
        this.$parent.handleTableChange(pagination);
      } catch {
        this.$emit("handleTableChange", pagination);
      }
    },
    showSizeChange(current, size) {
      let pagination = {
        current: 1,
        pageSize: size
      };
      try {
        this.$parent.handleTableChange(pagination);
      } catch {
        this.$emit("handleTableChange", pagination);
      }
    }
  }
};
</script>
